import React from "react";
import "../nav/Navigation.css";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import {User} from "../types/Types";
import AuthCheck from "../auth/AuthCheck";
import {faCamera, faMessage, faCoins, faHeart, faMap, faCheckCircle, faLocationDot} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface Props {
  user: User | undefined
  currentUser: User | undefined
}

function UserNav(props: Props) {
    const hasCheckIns = props.user && props.user.sessionCount > 0;

    return (
        <Container>
          <AuthCheck />
          <Nav variant="tabs" className="mb-2 mr-auto sub-menu-nav">
                {props.user && <>
                    <NavLink className="nav-link" to={`/profile/${props.user.id}/visits`} aria-label="Visits" title="Visits">
                        <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faCheckCircle}/>
                    </NavLink>
                    {(props.currentUser && !props.currentUser.socialDisabled && hasCheckIns) && <NavLink className="nav-link" to={`/profile/${props.user.id}/sessions`} aria-label="Check-ins" title="Check-ins">
                        <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faLocationDot}/>
                    </NavLink>}
                    {(props.currentUser && !props.currentUser.socialDisabled) && <NavLink className="nav-link" to={`/profile/${props.user.id}/comments`}>
                        <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faMessage}/>
                    </NavLink>}
                    {(props.currentUser && !props.currentUser.socialDisabled) && <NavLink className="nav-link" to={`/profile/${props.user.id}/photos`}>
                        <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faCamera}/>
                    </NavLink>}
                    {(props.currentUser && !props.currentUser.socialDisabled) && <NavLink className="nav-link" to={`/profile/${props.user.id}/likes`}>
                        <FontAwesomeIcon className="animated zoomIn fa-solid" icon={faHeart} />
                    </NavLink>}
                  {(props.currentUser && !props.currentUser.socialDisabled && hasCheckIns) && <NavLink className="nav-link" to={`/profile/${props.user.id}/points`}>
                      <FontAwesomeIcon className={"mr-1"} icon={faCoins}/> 
                  </NavLink>}
                  {(props.currentUser && !props.currentUser.socialDisabled && hasCheckIns) && <NavLink className="nav-link" to={`/journey/${props.user.id}`}>
                      <FontAwesomeIcon icon={faMap}/>
                  </NavLink>}
                </>}
            </Nav>
        </Container>
    )
}

export default UserNav;
